<template>
	<div v-if="detail.isAi">
		<div
			ref="fab"
			class="draggable-fab"
			:style="fabStyle"
			@mousedown="handleDown"
			@touchstart="handleDown"
			@click="handleClick"
		>
			<div>
				<van-icon name="cashier-o"/>
				<div class="draggable-fab_text">观看视频</div>
			</div>
		</div>

		<van-overlay :show="visible" z-index="100">
			<div class="video_box">
				<video
					ref="videoPlayer"
					class="video_inner"
					:src="detail.lukVideoUrl"
					controls
					playsinline
					webkit-playsinline
					x5-playsinline
					x5-video-player-type="h5"
					x5-video-player-fullscreen="false"
					preload="metadata"
				></video>

				<div class="video_button">
					<van-icon name="close" color="#FFF" size="32px" @click="clickClose" />
				</div>
			</div>
		</van-overlay>
	</div>
</template>

<script>
import moment from 'moment'
export default {
	name: "ai-luk-video",
	data: () => ({
		startPlayTime: 0,
		visible: false,
		isDragging: false,
		dragStartPos: {x: 0, y: 0}, // 记录按下时的位置
		position: {
			x: window.innerWidth - 80,
			y: window.innerHeight - 250
		},
		size: '56px'
	}),
	props: ['detail'],
	computed: {
		fabStyle() {
			return {
				width: this.size,
				height: this.size,
				left: this.position.x + 'px',
				top: this.position.y + 'px'
			};
		}
	},
	mounted() {
		document.addEventListener('mousemove', this.handleMove);
		document.addEventListener('mouseup', this.handleUp);
		document.addEventListener('touchmove', this.handleMove, {passive: false});
		document.addEventListener('touchend', this.handleUp);

		if (!this.$route.query.formType) {
			this.clickShowVideo()
		}
	},
	beforeDestroy() {
		document.removeEventListener('mousemove', this.handleMove);
		document.removeEventListener('mouseup', this.handleUp);
		document.removeEventListener('touchmove', this.handleMove);
		document.removeEventListener('touchend', this.handleUp);
	},
	methods: {
		handleDown(event) {
			event.stopPropagation();
			const client = this.getEventClient(event);
			this.dragStartPos = {x: client.x, y: client.y};
			this.isDragging = false; // 先假设是点击
			// 注意：这里不要 preventDefault，否则 click 会被阻断
		},

		handleMove(event) {
			if (!this.dragStartPos.x && !this.dragStartPos.y) return;

			const client = this.getEventClient(event);
			const dx = Math.abs(client.x - this.dragStartPos.x);
			const dy = Math.abs(client.y - this.dragStartPos.y);

			// 如果移动超过 5px，才认为是拖拽
			if (!this.isDragging && (dx > 5 || dy > 5)) {
				this.isDragging = true;
				// 此时才开始记录偏移（用于定位）
				const rect = this.$refs.fab.getBoundingClientRect();
				this.offset = {
					x: this.dragStartPos.x - rect.left,
					y: this.dragStartPos.y - rect.top
				};
			}

			if (this.isDragging) {
				event.preventDefault(); // 拖拽时才阻止默认行为
				let x = client.x - this.offset.x;
				let y = client.y - this.offset.y;

				const size = parseInt(this.size);
				const maxX = window.innerWidth - size;
				const maxY = window.innerHeight - size;
				x = Math.max(0, Math.min(x, maxX));
				y = Math.max(0, Math.min(y, maxY));

				this.position.x = x;
				this.position.y = y;
			}
		},

		handleUp() {
			this.dragStartPos = {x: 0, y: 0};
			this.isDragging = false;
		},

		handleClick(event) {
			// 只有在没有拖拽时才响应点击
			if (!this.isDragging) {
				this.clickShowVideo();
			}
		},

		clickShowVideo() {
			this.visible = true;
			this.startPlayTime = new Date().getTime()
			this.$nextTick(() => {
				const video = this.$refs.videoPlayer;
				if (video) {
					video.currentTime = 0;
					video.pause();
				}
			});
		},

		clickClose () {
			if (!this.$route.query.formType && this.detail.queWriteWatchTime) {
				const diff = moment().diff(moment(this.startPlayTime), 'minutes');
				if (diff < this.detail.queWriteWatchTime) {
					return this.$notify({ message: `观看时长未达标，请观看视频${ this.detail.queWriteWatchTime }分钟`, type: 'warning' })
				}
			}

			this.visible = false;
			const video = this.$refs.videoPlayer;
			if (video) {
				video.pause();
				video.currentTime = 0;
			}
		},

		getEventClient(event) {
			if (event.type.startsWith('touch')) {
				const touch = event.touches[0] || event.changedTouches[0];
				return {x: touch.clientX, y: touch.clientY};
			} else {
				return {x: event.clientX, y: event.clientY};
			}
		}
	}
};
</script>
<style scoped lang="less">
.draggable-fab {
	position: fixed;
	border: none;
	border-radius: 50%;
	color: white;
	font-size: 24px;
	cursor: move;
	box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);
	background-color: var(--color-primary);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 10;
	user-select: none; /* 禁止选中 */
	-webkit-user-drag: none; /* 禁用原生拖拽 */
	text-align: center;
	overflow: hidden;

	.draggable-fab_text {
		font-size: 10px;
	}
}

.video_box {
	height: 100vh;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	.video_inner {
		width: 100vw;
		height: calc(100vw / 16 * 9);
		vertical-align: middle;
		object-fit: contain;
	}

	.video_button {
		margin-top: 100px;
	}
}

</style>
